//src\customizations\volto\components\theme\SkipLinks\SkipLinks.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const SkipLinks = () => (

  <div className="skiplinks" role="complementary" aria-label="Skip links">
    <a className="visually-hidden-focusable" href="#view">Vai al contenuto</a>
    <a className="visually-hidden-focusable" href="#navigation">Vai alla navigazione</a>
    <a className="visually-hidden-focusable" href="#footer">Vai al footer</a>
  </div>

);

export default SkipLinks;